import { Component } from '@angular/core';
import { Catalog } from 'app/Model/Catalog/Catalog';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { LoginService } from 'app/Services/login.service';

@Component({
    selector: 'np-catalog-reference-sources',
    templateUrl: './catalog-reference-sources.component.html',
    styleUrl: './catalog-reference-sources.component.css',
    standalone: false
})
export class CatalogReferenceSourcesComponent {
  catalogs =[];

  get model(): Catalog {
    return this.catalogService.catalog;
  }

  set model(catalog: Catalog) {
    this.catalogService.catalog = catalog;
  }


  constructor(public catalogService: CatalogService, public loginService: LoginService) {
    this.catalogService.getCatalogs(this.loginService.currentCustomer.id).subscribe((result: Catalog[]) => {
      this.catalogs = result;
    });
  }

  openWikiUrl(): void {
      window.open("https://knowledge.nextpim.de/referenzen", '_blank');
  }

  valueChanged(e) {
    this.catalogService.catalogChanged(e);
  }
}
